// extracted by mini-css-extract-plugin
module.exports = {"save-button":"proa-summary_save-button__q00DN","form-buttons":"proa-summary_form-buttons__7GDB4"};